import React from 'react'

import { B2, H4, YStack } from '@zet/design-system'
import { i18n } from '@zet/localization'

const Header = () => {
  return (
    <YStack className="items-center justify-center bg-[#2C1F08] px-2 py-3">
      <H4 className="text-center text-white" style={{ lineHeight: 28 }}>
        {i18n.t('demoSale.h1')}
      </H4>
      <B2 className="mt-1 text-center text-white" style={{ lineHeight: 20 }}>
        {i18n.t('demoSale.sh1')}
      </B2>
    </YStack>
  )
}

export default Header
